<template>
  <div class="root" v-if="openTaskMenu">
    <input
      type="checkbox"
      class="all-checkbox"
      @click="checkSelectAll"
      :checked="selectAll"
      id="check-all"
    />
    <label class="label-check-all" for="check-all">All </label>
    <input type="checkbox" class="item-checkbox" :value="opt" id="exclude" />
    <label class="item-text" for="exclude">Exclusion</label>
    <div class="dropdown-divider"></div>
    <div class="scroller-div">
      <!--      <div v-if="showResults">
          <ul>
            <li v-for="(opt, idx) in result" :key="idx">
              <input
                type="checkbox"
                class="item-checkbox"
                v-model="selectedItems"
                :value="opt"
                :id="opt.id"
              />
              <label class="item-text" :title="opt.title " :for="opt.id">
                {{ opt.title  }}</label
              >
             <span class="item-counter">
                - {{ getStats(opt.id).count }}</span
              >
            </li>
          </ul>
        </div>-->
      <div v-if="openTaskMenu">
        <ul>
          <li
            v-for="(opt, idx) in options"
            :key="idx"
            v-if="getStats(opt.id).count > 0"
          >
            <input
              type="checkbox"
              class="item-checkbox"
              v-model="selectedItems"
              :value="opt"
              :id="opt.id"
            />
            <label class="item-text" :for="opt.id"> {{ opt.title }}</label>
            <span class="item-counter"> - {{ getStats(opt.id).count }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="tag-form-btns">
      <a
        class="tag-form-cancel-btn"
        href="javascript:void(0)"
        @click.prevent="closeSelect"
        ><span class="fas fa-times"></span
      ></a>

      <div class="loader-bottom">
        <loader v-if="requestClickBusy" :size="'3px'"></loader>
      </div>
      <button class="bttn-tab" @click="applyFilter">
        APPLY
      </button>
      <a
        class="tag-form-ok-btn"
        href="javascript:void(0)"
        @click.prevent="resetSelect"
        ><span class="fas fa-sync"></span
      ></a>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import apiClientCreator from "../../../../helpers/api/request";
import Loader from "../../../../main/misc.main/loader/Loader";

export default {
  name: "MultiSelect.component",
  components: { Loader },
  props: {
    options: {
      type: Array,
      required: true
    },
    resetList: {
      type: Boolean,
      required: false
    },

    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object
    },
    openTaskMenu: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  data() {
    return {
      selectedItems: [],
      infoData: [],
      // openMenu: false,
      showResults: false,
      searchTagQuery: "",
      result: [],
      showItemsCount: false,
      selectAll: false,
      typeStats: [],
      requestClickBusy: false
    };
  },
  watch: {
    queryObject: function() {
      if (this.openTaskMenu) {
        this.fetchStats();
      }
    },
    resetList: function() {
      if (this.resetList === true) {
        this.selectedItems = [];
      }
    },

    openTaskMenu: function() {
      if (this.openTaskMenu) {
        this.fetchStats();
      }
    },
    initiatedFiltering() {
      if (this.initiatedFiltering && this.typeStats.length > 0) {
        this.typeStats = [];
      }
    },
    selectedItems: function() {}
  },

  methods: {
    applyFilter() {
      this.$emit("input", this.selectedItems);
      this.closeSelect();
      this.fetchStats();
    },
    fetchStats() {
      this.typeStats = [];
      if (
        !this.requestClickBusy &&
        this.typeStats.length < this.options.length
      ) {
        this.requestClickBusy = true;
        apiClientCreator(`tasks/stats/ms/sub_status`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.typeStats = res.data;
            this.requestClickBusy = false;
          })
          .catch(err => {
            this.requestClickBusy = false;
          });
      }
    },
    getStats(i) {
      const stat = this.typeStats.find(item => item.status_type === i);
      if (stat === undefined) {
        return { count: "load..." };
      }
      return stat;
    },

    checkSelectAll: function() {
      this.selectedItems = [];
      let click;
      if (!this.selectAll) {
        for (click in this.options) {
          this.selectedItems.push(this.options[click]);
        }
      }
      this.selectAll = !this.selectAll;
    },
    closeSelect() {
      this.searchTagQuery = "";
      this.showResults = false;
      this.openTaskMenu = false;
    },
    resetSelect() {
      this.selectedItems = [];
      this.selectAll = false;
      this.typeStats = [];
      this.$emit("input", this.selectedItems);

      this.$emit("reset");
      this.closeSelect();
    }
    /*    filterList(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.options.filter(item => {
        return searchRegex.test(item.title);
      });
    }*/
  }
};
</script>

<style scoped>
.root {
  position: absolute;
  top: 32px;
  right: 10px;
  width: max-content;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 5px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.item-text {
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
}
.item-checkbox {
  margin-right: 5px;
}
.item-counter {
  font-size: 8pt;

  margin-left: 10px;
}
.scroller-div {
  height: auto;
  max-height: 120px;
  overflow-x: hidden;
}
.label-check-all {
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
  margin-right: 20px;
}
.all-checkbox {
  vertical-align: middle;
  margin-bottom: 5px;
  margin-right: 5px;
  text-align: left;
}
.tag-form-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}

.tag-form-ok-btn {
  color: green !important;
  float: left;
  margin-left: 5px;
  margin-top: 5px;
}
.input-main {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}
input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /* padding: 3px 0px 3px 3px;*/
  border: 1px solid rgba(81, 203, 238, 1);
}
.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.loader-bottom {
  position: absolute;
  bottom: -5px;
  left: 26%;
}
.bttn-tab {
  width: max-content;
  margin-top: 0.3rem;
  margin-left: 0.5rem;
  background: #efefef;
  color: black;
  border: 0;
  border-radius: inherit;
  padding: 3px;
  font-size: 11px;
  font-weight: 400;
  font-family: inherit;
  cursor: pointer;
  height: 22px;
}
.bttn-tab:focus {
  outline: none;
}
</style>
